import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const ModalSendSurvey = styled.div`
  display: ${({hidden}) =>  hidden ? 'none' : 'flex' };
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  .modal-background {
    background-color: ${`#090949${getHexOpacity(0.50)}`};
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 100;
  }
  .modal-reaction {
    padding: 40px 0px;
  }
  .modal-container {
    box-shadow: 0px 3px 10px 3px #1C1F5833;
    height: ${({completeScreen}) =>  completeScreen ? '100%' : '90%' };
    z-index: 200;
    background: ${({completeScreen}) =>  completeScreen ? '#EFEFF9' : 'linear-gradient(128.98deg, #EFEFF9 27.64%, #E1E1F0 96.67%)' };
    width: 100%;
    margin-top: auto;
    box-sizing: border-box;
    /* max-height: 80%; */
    /* overflow-y: auto; */
    border-radius: 14px;
    padding: 40px 120px;
    .header {
      padding: 15px 40px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #0000002B;
      &__title {
        font-size: 32.25px;
        font-family: Nunito Sans Bold;
        font-size: 19.08px;
        color: #000000;
      }
      &__close {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        cursor: pointer;
        color: #000;
      }
    }
    .modal-content-dinamic {
      height: 100%;
      .dinamic-component {
        height: 100%;
      }
    }
    .survey-options {
      height: 100%;
      display: flex;
      flex-direction: column;
      &__text {
        font-family: Nunito Sans Light;
        font-size: 45px;
        color: #1F1F52;
      }
      &__subtitle  {
        font-family: Nunito Sans;
        font-size: 25px;
        color: #1F1F52;
      }
    }
    .modal-tabs {
      display: flex;
      margin-top: 60px;
      background-color: #FFFFFF;
      width: min-content;
      padding: 5px;
      border-radius: 20px;
      align-items: center;
      .tab-separator {
        height: 14px;
        border-right: 1px solid var(--Backgrounds-Separador-I, #CFD3DD);
        margin: 0 10px;
      }
      .tab {
        cursor: pointer;
        display: flex;
        width: 200px;
        height: 40px;
        padding: 0 40px;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        font-family: "Nunito Sans";
        font-size: 18px;
        color: #2A28D6;
        &--selected {
          border: 1px solid;
          border-image-source: linear-gradient(108.72deg, #5E5DD2 13.16%, rgba(255, 255, 255, 0.0704939) 38.65%, rgba(255, 255, 255, 0.3623) 65.98%, rgba(255, 255, 255, 0.382306) 77.46%, #FFFFFF 92.77%);
          color: #FFFFFF;
          background-color: #6C6BF5;

          box-shadow: 10px 6px 9.5px -6px #FFFFFF;

          box-shadow: -5px -4px 6.6px -4px #FFFFFF40 inset;

        }
      }
    }    
    .options {
      display: flex;
      margin-top: auto;
      width: 100%;
      padding: 10px 20px;
      border: 2px solid #FFFFFF;
      display: flex;
      justify-content: space-between;
      border-radius: 20px;
      box-sizing: border-box;
      &__right {
        display: flex;
        // each child has margin left 10px
        & > *:not(:first-child) {
          margin-left: 10px;
        }
      }
    } 
  }
  
  

  @media only screen and (max-width: 435px) {
    .buttons-container {
      .button-submit {
        button {
          /* width: 70%; */
          margin: auto;
        }
      }
      .button-close {

      }
    } 
  }
`;

export const InputOption = styled.div`
  padding: 12px 25px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  min-width: 100px;
  background-color: ${({theme, backgroundColor}) => backgroundColor ? backgroundColor : theme.inputBackground};
  margin-bottom: 10px;
  position: relative;
  opacity: ${({disabled}) => disabled ? "0.3" : ""};
  cursor: ${({disabled}) => disabled ? "" : "pointer"};
  border: ${
    ({ 
      selected
    }) => 
      {
        if(selected) {
          return '2px solid #6C6BCC'
        } else {
          return '1px solid #36369B'
        }
      }
  };
  .input-icon {
    font-size: 14px;
    margin-right: 5px;
    color: #36369B;
  }
  .input-text {
    font-family: "Nunito Sans";
    font-size: 14px;
    color: ${({selected, filled}) => selected ? "#36369B" : filled ? "#6C6BCC": "#3E3E5B"};
    cursor: ${({disabled}) => disabled ? "deafult" : "pointer"};
    b {
      margin-left: 5px;
    }
  }
  .input-icon-arrow {
    color: ${({selected}) => selected ? "#36369B" : "#6C6BCC"};
    font-size: 12px;
    transition: .3s ease;
    transform: ${({selected}) => selected ? 'rotate(270deg)' : 'rotate(90deg)'};
    margin-left: auto;
  }
  .input-icon-check {
    color: ${({selected}) => selected ? "#36369B" : "#6C6BCC"};
    font-size: 11px;
    margin-left: auto;
  }
  .shape-container {
    position: absolute;
    right: -23px;
    top: 10px;
  }
`